import React from 'react';
import MyContext from './shared/context';  // Import your context
import { useLocation, useParams, useNavigate } from 'react-router-dom';

// Higher-Order Component to inject context as a prop
function withContext(Component) {
  const ContextComponent=(props) =>{
      const location = useLocation();
        const params = useParams();
        const navigate = useNavigate();
    return (
      <MyContext.Consumer>
        {(context) => {
          if (!context) {
            console.error('Context is undefined, make sure the component is wrapped with a Provider');
          }
          // Ensure the context is passed as a prop to the wrapped component
          return <Component
                        {...props}     
                        location={location}
                        params={params}
                        navigate={navigate}
                        staticContext={context} />;
        }}
      </MyContext.Consumer>
    );
  };
  ContextComponent.initialAction = Component.initialAction;
  return ContextComponent;
}

export default withContext;
